import { useTranslate } from 'react-polyglot';

import {
  BaseModal,
  BasicParagraph,
  BiggerSubtitle,
  Button,
} from '@genially/design-system';

import {
  ButtonsWrapper,
  ContentWrapper,
  StyledBasicParagraph,
  StyledBiggerSubtitle,
} from './NoPlayersModal.styled';

export const NoPlayersModal = ({
  closeModal,
  parentElement,
  onConfirm,
}: {
  parentElement: HTMLElement;
  closeModal: () => void;
  onConfirm: () => void;
}) => {
  const t = useTranslate();

  const handleConfirmButtonClick = () => {
    onConfirm();
    closeModal();
  };

  const handleClose = () => {
    closeModal();
  };

  return (
    <BaseModal
      close={closeModal}
      parentElement={parentElement}
      width={BaseModal.Size.SMALL}
    >
      <BaseModal.Header>
        <StyledBiggerSubtitle>
          {t('__new.play.noParticipants.creator.modal.title')}
        </StyledBiggerSubtitle>
      </BaseModal.Header>

      <BaseModal.Content>
        <ContentWrapper>
          <StyledBasicParagraph>
            {t('__new.play.noParticipants.creator.modal.description')}
          </StyledBasicParagraph>
        </ContentWrapper>
      </BaseModal.Content>

      <BaseModal.Footer>
        <ButtonsWrapper>
          <Button variant={Button.Variant.PLAIN} onClick={handleClose}>
            {t('__new.play.noParticipants.creator.modal.cancelButton')}
          </Button>

          <Button variant={Button.Variant.ACTION} onClick={handleConfirmButtonClick}>
            {t('__new.play.noParticipants.creator.modal.startButton')}
          </Button>
        </ButtonsWrapper>
      </BaseModal.Footer>
    </BaseModal>
  );
};
